import axiosTokenInstance from '../../../services/api/backoffice';

import { UNBARRING_ACTION, UNBARRING_ACTION_ERROR } from '_models/redux/types';

// Action function
export const postUnbarringAction =
  (sessionIncidence = undefined) =>
  async (dispatch) => {
    // Endpoint: Try & Catch
    try {
      const response = await axiosTokenInstance.post(
        `/api/support/tickets/${sessionIncidence}/actions/unbarring`,
      );

      const { data } = response || {};

      dispatch({
        type: UNBARRING_ACTION,
        payload: data || {},
      });
    } catch (e) {
      dispatch({
        type: UNBARRING_ACTION_ERROR,
        payload: e || {},
      });
    }
  };
